import * as core from '../../../../../../../core'
import * as proposalStatus from '../proposal-status'

export const RESOURCE = {
  payload: {
    description: 'No Bid',
    enumId: core.dms.models.Enum.Id.from({
      partialId: proposalStatus.RESOURCE.payload.partialId,
    }),
    id: 'No Bid',
    name: 'No Bid',
  },
  type: core.quiver.Resource.Type.DmsEnumEntry,
} as const satisfies core.quiver.Resource<core.quiver.Resource.Type.DmsEnumEntry>
